<template>
    <div class="user-sites">
        <transition-group
            name="fade"
            mode="out-in"
        >
            <template v-if="!licenses">
                <div
                    :key="'loader'"
                    class="loader"
                >
                    <i class="fas fa-spinner fa-spin loader" />
                </div>
            </template>
            <template v-else>
                <license-content key="license-content" settings-page="sites" />
            </template>
        </transition-group>
    </div>
</template>

<script>
import LicenseContent from '@/components/Dashboard/Settings/LicenseContent';

import { mapState } from 'vuex';

export default {
    components: {
        LicenseContent,
    },

    data: () => ({
        loadedSubscription: false,
    }),

    computed: {
        ...mapState([
            'user',
            'licenses',
        ]),
    },
};
</script>
